import React from 'react';
import styles from '../../styles/ContactUs/ContactForm.module.css';

const ContactForm = () => {
  return (
    <div className={styles.formSection}>
      <h3>Please fill out the form below, and our team will get back to you promptly.</h3>
      <form className={styles.form}>
        <div className={styles.double}>
          <input type="text" placeholder="First Name" />
          <input type="text" placeholder="Last Name" />
        </div>
        <div className={styles.double}>
          <input type="email" placeholder="Email Address" />
          <input type="text" placeholder="Phone Number" />
        </div>
        <input type="text" placeholder="Subject" />
        <textarea rows="5" placeholder="Message"></textarea>
        <button type="submit">Contact Us</button>
      </form>
    </div>
  );
};

export default ContactForm;
